import React, { useState } from 'react'
import { node, string, array } from 'prop-types'

const ScrollContext = React.createContext()

const ScrollProvider = ({ children, initialStep, categories }) => {
  const [category, setCategory] = useState(initialStep)
  const [anchor, setAnchor] = useState(initialStep)

  const handleCategoryChange = anchor => {
    if (categories.includes(anchor)) setCategory(anchor)
  }

  const goToAnchor = anchor => {
    window.location.hash = anchor
    setAnchor(anchor)
  }

  const value = {
    category,
    anchor,
    goToAnchor,
    handleCategoryChange
  }

  return <ScrollContext.Provider value={value}>{children}</ScrollContext.Provider>
}

ScrollProvider.propTypes = {
  children: node.isRequired,
  initialStep: string,
  categories: array
}

const { Consumer } = ScrollContext

export { Consumer as ScrollConsumer, ScrollProvider }

export default ScrollContext
